import { render } from "./ReportTotalsByBucketSize.vue?vue&type=template&id=11537540&scoped=true"
import script from "./ReportTotalsByBucketSize.vue?vue&type=script&lang=js"
export * from "./ReportTotalsByBucketSize.vue?vue&type=script&lang=js"

import "./ReportTotalsByBucketSize.vue?vue&type=style&index=0&id=11537540&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11537540"]])

export default __exports__